export const raFormLayout = {
  action: {
    next: "Próximo",
    previous: "Anterior",
    bulk_update: "Atualizar %{resource} selecionado",
  },
  autosave: {
    last_saved_at: "Todas as alterações salvas",
    saving: "Salvando...",
    error: "Erro no servidor, alterações não salvas: %{error}",
  },
  auto_persist_in_store: {
    applied_changes: "Aplicadas alterações não salvas anteriores",
  },
  filters: {
    apply_filters: "Aplicar",
    remove_all_filters: "Remover todos os filtros",
    filters_button_label: "Filtros",
    source: "Campo",
    operator: "Operador",
    value: "Valor",
    operators: {
      q: "Contém",
      eq: "Igual a",
      ne: "Diferente de",
      neq: "Diferente de",
      gt: "Maior que",
      gte: "Maior ou igual a",
      lt: "Menor que",
      lte: "Menor ou igual a",
      in: "Está em",
      eq_any: "Igual a qualquer",
      neq_any: "Diferente de qualquer",
      boolean: "É verdadeiro",
      inc: "Inclui",
      inc_any: "Inclui qualquer",
      ninc_any: "Não inclui nenhum",
      null: "Não preenchido ou vazio",
      notnull: "Preenchido",
      isEmpty: "Não preenchido ou vazio",
      isNotEmpty: "Preenchido",
      contains: "Contém",
      equals: "Igual a",
      notEquals: "Diferente de",
    },
  },
  input_selector_form: {
    select_inputs: "Selecionar campos",
    select_values: "Selecionar valores",
  },
};
